"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultConfig = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const simple_select_1 = require("@kyruus/simple-select");
const read_only_1 = __importDefault(require("../../read-only"));
const use_form_1 = __importDefault(require("../../../form/use-form"));
const styles_1 = require("../../../styles");
const SimpleSelectInput = (props) => {
    var _a;
    const { path } = props;
    const [state, actions] = (0, use_form_1.default)(path, {
        eventProcessor: (event) => {
            return event.target.value;
        }
    });
    const { AddOn } = state;
    if (!state.config.isVisible)
        return null;
    if (state.config.isReadOnly) {
        const label = state.value.label ||
            ((_a = state.config.options.find((option) => option.value === state.value)) === null || _a === void 0 ? void 0 : _a.label);
        return react_1.default.createElement(read_only_1.default, { msg: label });
    }
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(styles_1.FieldFocusWrapper, { hasError: !!state.errors.length },
            react_1.default.createElement(simple_select_1.SingleSelect, { errors: state.errors, onChange: actions.onChange, onBlur: actions.onBlur, value: state.value, placeholder: state.config.placeholder, disabled: state.config.sReadOnly, name: path, "aria-label": state.config.label || props.label, options: state.config.options, "data-testid": path, autoComplete: props.autoComplete, "aria-invalid": Boolean(state.errors.length) })),
        react_1.default.createElement(AddOn, null)));
};
SimpleSelectInput.propTypes = {
    path: prop_types_1.default.string.isRequired,
    label: prop_types_1.default.string,
    autoComplete: prop_types_1.default.string
};
exports.default = SimpleSelectInput;
exports.defaultConfig = {};
//# sourceMappingURL=index.js.map